import { FC } from 'react';
import { ConfigurationVariable } from '@/types/metadata/metadata';
import { variableUtil } from '@/util/validation/variable';
import { ParamProps } from './ParamRenderer';
import VariableView from './VariableView';

const ParamVariable: FC<ParamProps> = (props) => {
  const configuration = props.configuration as ConfigurationVariable;

  const initialValue = variableUtil().getValue(props.configuration, props.initialValue);

  return (
    <VariableView
      label={configuration.label}
      subroutineId={props.parentId}
      type={configuration.subtype}
      valueKey={configuration.value}
      initialValue={initialValue}
      onChange={(newVariable) => props.onChange([configuration.value, newVariable])}
      required={props.configuration.required}
      errorSeverity={props.errors && props.errors[0]?.severity}
    />
  );
};

export default ParamVariable;
